/*
 * Olivia Star — dots under the product gallery on phones (30.09.2026, Magonya: «кружки, значок плей у видео,
 * ближе к фото, поднять название, чтобы сразу было видно УТП»).
 * Replaces Dawn's "‹ 3/8 ›" row below 750px: one dot per visible slide, a ▶ for video slides,
 * tap a dot to jump, the active dot follows swipes. Desktop keeps Dawn's layout.
 */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 749px)');

  function build(gallery) {
    if (!gallery || gallery.__oliviaDots) return;
    var slider = gallery.querySelector('slider-component');
    var list = slider && slider.querySelector('.product__media-list');
    if (!list) return;
    gallery.__oliviaDots = true;

    var nav = document.createElement('div');
    nav.className = 'olivia-dots';
    nav.setAttribute('role', 'tablist');
    slider.insertBefore(nav, list.nextSibling);

    function slides() {
      return Array.prototype.filter.call(list.querySelectorAll('.product__media-item'), function (li) {
        return li.offsetParent !== null && li.offsetWidth > 0;
      });
    }

    var current = -1;
    function render() {
      var items = slides();
      nav.innerHTML = '';
      nav.hidden = items.length < 2;
      items.forEach(function (li, i) {
        var b = document.createElement('button');
        var video = !!li.querySelector('.media-type-video, .media-type-external_video');
        b.type = 'button';
        b.className = 'olivia-dots__dot' + (video ? ' olivia-dots__dot--video' : '');
        b.setAttribute('aria-label', (video ? 'Video ' : 'Photo ') + (i + 1) + ' / ' + items.length);
        b.addEventListener('click', function () {
          list.scrollTo({ left: li.offsetLeft - list.offsetLeft, behavior: 'smooth' });
        });
        nav.appendChild(b);
      });
      current = -1;
      sync();
    }

    function sync() {
      var items = slides();
      if (!items.length) return;
      var x = list.scrollLeft + list.clientWidth / 2, best = 0, dist = Infinity;
      items.forEach(function (li, i) {
        var c = li.offsetLeft - list.offsetLeft + li.offsetWidth / 2, d = Math.abs(c - x);
        if (d < dist) { dist = d; best = i; }
      });
      if (best === current) return;
      current = best;
      // Amazon-style window (Magonya 30.09): at most 5 dots, the selected one big, neighbours medium,
      // the rest small; the window slides with the photo
      var n = nav.children.length, start = Math.max(0, Math.min(best - 2, n - 5)), end = Math.min(n - 1, start + 4);
      Array.prototype.forEach.call(nav.children, function (b, i) {
        var d = Math.abs(i - best);
        var edge = (i === start && start > 0) || (i === end && end < n - 1);
        b.classList.toggle('is-active', i === best);
        b.classList.toggle('is-near', d === 1 && !edge);
        b.classList.toggle('is-far', d >= 2 || (edge && d > 0));
        b.classList.toggle('is-out', i < start || i > end);
        b.setAttribute('aria-selected', i === best ? 'true' : 'false');
      });
    }

    var raf = 0;
    list.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; sync(); });
    }, { passive: true });
    // variant change can hide/show variant images
    new MutationObserver(function () { render(); }).observe(list, { subtree: true, attributes: true, attributeFilter: ['class', 'hidden', 'style'] });
    window.addEventListener('resize', function () { current = -1; sync(); });
    render();
  }

  function init() {
    if (!MQ.matches) return;
    document.querySelectorAll('media-gallery').forEach(build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  MQ.addEventListener ? MQ.addEventListener('change', init) : MQ.addListener(init);
})();
